import { render, staticRenderFns } from "./PcnCard.vue?vue&type=template&id=195038e2"
import script from "./PcnCard.vue?vue&type=script&lang=js"
export * from "./PcnCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports